import Vue from 'vue'
import VueRouter from 'vue-router'
import ChatWindow from '../views/ChatWindow/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'chatWindow',
    component: ChatWindow
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
